import type { FaireProductEntity } from "../../entity_types/product";

export const p_prxeovi8ya: FaireProductEntity = {
  token: "p_prxeovi8ya",
  type: "product",
  name: "Charcuterie & Cheese Board *",
  brandName: "Ten Thousand Villages",
  imageUrl:
    "https://cdn.faire.com/fastly/885135042a5b54f042065c0a3a06c971456be5774b1fbf7f4608cc3aa699b874.jpeg",
  priceDollars: 10,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/a7e00c630987227a6d038639f761c07b2fef3a10362e37bd043e46f248307264.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
